(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
(function() {

  var BUNDLES = {
    'palo-alto': {
      name: 'Palo Alto', price: 249,
      finishes: 'Soft Matte', hasPremium: false,
      sizes: [
        { id: 'sz2', label: '2" Stickers', total: 300 },
        { id: 'sz3', label: '3" Stickers', total: 100 }
      ]
    },
    'menlo-park': {
      name: 'Menlo Park', price: 349,
      finishes: 'Soft Matte + 1 premium', hasPremium: true,
      sizes: [
        { id: 'sz2', label: '2" Stickers', total: 400 },
        { id: 'sz3', label: '3" Stickers', total: 200 },
        { id: 'sz4', label: '4" Stickers', total: 100 }
      ]
    },
    'atherton': {
      name: 'Atherton', price: 549,
      finishes: 'All 4 finishes', hasPremium: false,
      sizes: [
        { id: 'sz2',   label: '2" Stickers',            total: 700 },
        { id: 'sz34',  label: '3" or 4" Stickers',      total: 300, sizeChoice: ['3"','4"'] },
        { id: 'sz15',  label: '1.5" Mini Stickers',     total: 50 },
        { id: 'szholo',label: '3" Holographic Hero',    total: 25, fixed: true, fixedFinish: 'Holographic' },
        { id: 'sztext',label: '3" Textured Matte Hero', total: 25, fixed: true, fixedFinish: 'Textured Matte' }
      ]
    }
  };

  var PREMIUM_LABELS = { 'textured-matte': 'Textured Matte', 'holographic': 'Holographic' };

  var s = { bundle: 'palo-alto', premium: 'textured-matte', splits: {}, sizeChoices: {}, designs: {}, comments: {} };
  var interacted = { bundle: false, sizes: false, premium: false };

  function getBundle() { return BUNDLES[s.bundle]; }

  function bbShake(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.classList.remove('df-shake');
    void el.offsetWidth;
    el.classList.add('df-shake');
    el.addEventListener('animationend', function h() { el.classList.remove('df-shake'); el.removeEventListener('animationend', h); });
  }
  function bbHint(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.classList.add('visible');
    clearTimeout(el._t);
    el._t = setTimeout(function() { el.classList.remove('visible'); }, 4500);
  }
  function updateRequiredTags() {
    var hasPremium = getBundle().hasPremium;
    var tags = {
      'bb-req-bundle':  interacted.bundle  && !!s.bundle,
      'bb-req-sizes':   interacted.sizes   && Object.keys(s.splits).length > 0,
      'bb-req-premium': interacted.premium && (!hasPremium || !!s.premium)
    };
    Object.keys(tags).forEach(function(id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.classList.toggle('df-required-tag--done', tags[id]);
      el.textContent = tags[id] ? '✓ Done' : 'Required';
    });
  }

  function initSplits() {
    s.splits = {}; s.sizeChoices = {};
    getBundle().sizes.forEach(function(sz) {
      if (!sz.fixed) {
        s.splits[sz.id] = { dieCut: sz.total, clear: 0 };
        if (sz.sizeChoice) s.sizeChoices[sz.id] = sz.sizeChoice[0];
      }
    });
  }

  function getFinishesLabel() {
    var b = getBundle();
    return b.hasPremium ? 'Soft Matte + ' + PREMIUM_LABELS[s.premium] : b.finishes;
  }

  function addToCart() {
    // Validate required selections
    if (!s.bundle)                         { bbShake('bb-bundle');  bbHint('bb-hint-bundle');  return; }
    if (Object.keys(s.splits).length === 0){ bbShake('bb-size-configs'); bbHint('bb-hint-sizes'); return; }
    if (getBundle().hasPremium && !s.premium){ bbShake('bb-premium'); bbHint('bb-hint-premium'); return; }

    var root = document.getElementById('bundle-builder');
    var variantMap = {
      'palo-alto':  +root.dataset.paVariant,
      'menlo-park': +root.dataset.mpVariant,
      'atherton':   +root.dataset.atVariant
    };
    var variantId = variantMap[s.bundle];
    if (!variantId) {
      alert('Bundle product not yet configured in the theme editor. Please contact hello@daintyfavors.com to order.');
      return;
    }

    var b = getBundle();
    var props = { 'Bundle': b.name, 'Finish': getFinishesLabel() };
    b.sizes.forEach(function(sz) {
      if (sz.fixed) {
        props[sz.label] = sz.total + ' (' + sz.fixedFinish + ')';
      } else {
        var sp = s.splits[sz.id] || { dieCut: sz.total, clear: 0 };
        var name = sz.label;
        if (sz.sizeChoice) name += ' (' + (s.sizeChoices[sz.id] || sz.sizeChoice[0]) + ')';
        var parts = [];
        if (sp.dieCut > 0) parts.push(sp.dieCut + ' standard');
        if (sp.clear > 0) parts.push(sp.clear + ' clear');
        props[name] = parts.length ? parts.join(' + ') : sz.total + ' standard';
        var design = s.designs[sz.id];
        if (design) props[name + ' — Design'] = design + ' (email file to hello@daintyfavors.com)';
        var comment = s.comments[sz.id];
        if (comment && comment.trim()) props[name + ' — Notes'] = comment.trim();
      }
    });

    var btn = document.getElementById('bb-cta');
    var label = document.getElementById('bb-cta-label');
    btn.disabled = true;
    label.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: props })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      btn.disabled = false;
      label.textContent = 'Add to Cart';
      if (data.status) {
        alert('Could not add to cart: ' + (data.description || 'please try again.'));
      } else {
        document.getElementById('bb-success').hidden = false;
      }
    })
    .catch(function() {
      btn.disabled = false;
      label.textContent = 'Add to Cart';
    });
  }

  function renderSizeConfigs() {
    var container = document.getElementById('bb-size-configs');
    container.innerHTML = '';
    getBundle().sizes.forEach(function(sz) {
      var card = document.createElement('div');
      card.className = 'bb__size-card' + (sz.fixed ? ' bb__size-card--fixed' : '');

      // Header
      var fixedTag = sz.fixed ? ' &nbsp;·&nbsp; <em>' + sz.fixedFinish + '</em>' : '';
      var head = '<div class="bb__size-card-head">'
        + '<span class="bb__size-name">' + sz.label + '</span>'
        + '<span class="bb__size-count">' + sz.total + ' stickers' + fixedTag + '</span>'
        + '</div>';

      var body = '';
      if (sz.fixed) {
        body = '<p class="bb__size-fixed-note">Included as a fixed-finish hero in the Atherton bundle.</p>';
      } else {
        // Optional 3"/4" size choice
        var choiceHtml = '';
        if (sz.sizeChoice) {
          var cur = s.sizeChoices[sz.id] || sz.sizeChoice[0];
          choiceHtml = '<div class="bb__size-choice" data-sz="' + sz.id + '">'
            + sz.sizeChoice.map(function(c) {
              return '<button class="bb__size-choice-btn' + (c === cur ? ' bb__size-choice-btn--active' : '') + '" data-choice="' + c + '" type="button">' + c + '</button>';
            }).join('') + '</div>';
        }

        var split = s.splits[sz.id] || { dieCut: sz.total, clear: 0 };
        var splitHtml = '<div class="bb__split">'
          + choiceHtml
          + '<div class="bb__split-row">'
          + '<div class="bb__split-col">'
          + '<label class="bb__split-label">Standard</label>'
          + '<input class="bb__split-input" type="number" min="0" max="' + sz.total + '" value="' + split.dieCut + '" data-sz="' + sz.id + '" data-t="die-cut">'
          + '</div>'
          + '<span class="bb__split-plus">+</span>'
          + '<div class="bb__split-col">'
          + '<label class="bb__split-label">Clear</label>'
          + '<input class="bb__split-input" type="number" min="0" max="' + sz.total + '" value="' + split.clear + '" data-sz="' + sz.id + '" data-t="clear">'
          + '</div>'
          + '<span class="bb__split-total">= ' + sz.total + '</span>'
          + '</div></div>';

        var commentVal = (s.comments[sz.id] || '').replace(/&/g,'&amp;').replace(/</g,'&lt;');
        var designHtml = '<div class="bb__design">'
          + '<label class="bb__design-label">Design for ' + sz.label.toLowerCase() + '</label>'
          + '<div class="bb__upload-zone" role="button" tabindex="0" data-sz="' + sz.id + '">'
          + '<input type="file" class="bb__upload-input" accept=".ai,.eps,.pdf,.svg,.png,.jpg,.jpeg" style="position:absolute;opacity:0;pointer-events:none;width:1px;height:1px;">'
          + '<svg class="bb__upload-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>'
          + '<p class="bb__upload-text">Drop file or <span class="bb__upload-browse">browse</span></p>'
          + '<p class="bb__upload-hint">AI, EPS, PDF, SVG, PNG &middot; 50MB max</p>'
          + '<p class="bb__upload-filename"></p>'
          + '</div>'
          + '<label class="bb__design-label" style="margin-top:0.5rem;">Notes <span class="bb__comment-optional">(optional)</span></label>'
          + '<textarea class="bb__comment-textarea" placeholder="Colors, cut lines, special instructions for this size…" data-sz="' + sz.id + '">' + commentVal + '</textarea>'
          + '</div>';

        body = splitHtml + designHtml;
      }

      card.innerHTML = head + body;
      container.appendChild(card);
    });

    // Bind split inputs
    container.querySelectorAll('.bb__split-input').forEach(function(inp) {
      inp.addEventListener('input', function() {
        var szId = inp.dataset.sz;
        var type = inp.dataset.t;
        var total = 0;
        getBundle().sizes.forEach(function(sz) { if (sz.id === szId) total = sz.total; });
        var val = Math.min(Math.max(0, parseInt(inp.value) || 0), total);
        inp.value = val;
        if (!s.splits[szId]) s.splits[szId] = { dieCut: total, clear: 0 };
        s.splits[szId][type === 'die-cut' ? 'dieCut' : 'clear'] = val;
        s.splits[szId][type === 'die-cut' ? 'clear' : 'dieCut'] = total - val;
        var sibling = container.querySelector('.bb__split-input[data-sz="' + szId + '"][data-t="' + (type === 'die-cut' ? 'clear' : 'die-cut') + '"]');
        if (sibling) sibling.value = total - val;
        interacted.sizes = true;
        updateSummary();
      });
    });

    // Bind size choice buttons
    container.querySelectorAll('.bb__size-choice-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var wrap = btn.closest('.bb__size-choice');
        var szId = wrap.dataset.sz;
        wrap.querySelectorAll('.bb__size-choice-btn').forEach(function(b) { b.classList.remove('bb__size-choice-btn--active'); });
        btn.classList.add('bb__size-choice-btn--active');
        s.sizeChoices[szId] = btn.dataset.choice;
        updateSummary();
      });
    });

    // Bind upload zones
    container.querySelectorAll('.bb__upload-zone').forEach(function(zone) {
      var szId = zone.dataset.sz;
      var input = zone.querySelector('.bb__upload-input');
      var filenameEl = zone.querySelector('.bb__upload-filename');

      function setFile(file) {
        if (!file) return;
        s.designs[szId] = file.name;
        filenameEl.textContent = '✓ ' + file.name;
        zone.classList.add('bb__upload-zone--has-file');
        updateSummary();
      }

      zone.addEventListener('click', function(e) { if (e.target !== input) input.click(); });
      zone.addEventListener('keydown', function(e) { if (e.key === 'Enter' || e.key === ' ') input.click(); });
      zone.addEventListener('dragover', function(e) { e.preventDefault(); zone.classList.add('bb__upload-zone--drag'); });
      zone.addEventListener('dragleave', function() { zone.classList.remove('bb__upload-zone--drag'); });
      zone.addEventListener('drop', function(e) {
        e.preventDefault();
        zone.classList.remove('bb__upload-zone--drag');
        if (e.dataTransfer.files[0]) setFile(e.dataTransfer.files[0]);
      });
      input.addEventListener('change', function() { if (input.files[0]) setFile(input.files[0]); });

      // Restore filename if bundle switched back
      if (s.designs[szId]) {
        filenameEl.textContent = '✓ ' + s.designs[szId];
        zone.classList.add('bb__upload-zone--has-file');
      }
    });

    // Bind comment textareas
    container.querySelectorAll('.bb__comment-textarea').forEach(function(ta) {
      ta.addEventListener('input', function() { s.comments[ta.dataset.sz] = ta.value; updateSummary(); });
    });
  }

  function updateSummary() {
    var b = getBundle();
    document.getElementById('bb-lbl-name').textContent = b.name;
    document.getElementById('bb-lbl-finishes').textContent = getFinishesLabel();
    document.getElementById('bb-price').textContent = '$' + b.price;

    var wrap = document.getElementById('bb-summary-sizes');
    wrap.innerHTML = '';
    b.sizes.forEach(function(sz) {
      var row = document.createElement('div');
      row.className = 'bb__summary-size-row';
      var lbl = sz.label;
      if (sz.sizeChoice) lbl += ' (' + (s.sizeChoices[sz.id] || sz.sizeChoice[0]) + ')';
      var val = '';
      if (sz.fixed) {
        val = sz.total + ' · ' + sz.fixedFinish;
      } else {
        var sp = s.splits[sz.id] || { dieCut: sz.total, clear: 0 };
        var parts = [];
        if (sp.dieCut > 0) parts.push(sp.dieCut + ' standard');
        if (sp.clear > 0) parts.push(sp.clear + ' clear');
        val = parts.length ? parts.join(' + ') : sz.total + ' standard';
      }
      row.innerHTML = '<span class="bb__sum-sz-label">' + lbl + '</span><span class="bb__sum-sz-val">' + val + '</span>';
      wrap.appendChild(row);
    });

    document.getElementById('bb-success').hidden = true;
    updateRequiredTags();
  }

  // Bundle selection
  document.getElementById('bb-bundle').querySelectorAll('.bb__bundle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.getElementById('bb-bundle').querySelectorAll('.bb__bundle').forEach(function(b) { b.classList.remove('bb__bundle--active'); });
      btn.classList.add('bb__bundle--active');
      s.bundle = btn.dataset.bundle;
      s.designs = {}; s.comments = {};
      interacted.bundle = true;
      initSplits();
      document.getElementById('bb-premium-step').hidden = !getBundle().hasPremium;
      renderSizeConfigs();
      updateSummary();
    });
  });

  // Premium finish
  document.getElementById('bb-premium').querySelectorAll('.bb__option').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.getElementById('bb-premium').querySelectorAll('.bb__option').forEach(function(b) { b.classList.remove('bb__option--active'); });
      btn.classList.add('bb__option--active');
      s.premium = btn.dataset.value;
      interacted.premium = true;
      updateSummary();
    });
  });

  // CTA
  document.getElementById('bb-cta').addEventListener('click', addToCart);

  // Init
  initSplits();
  renderSizeConfigs();
  updateSummary();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle-comparison"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var tabs = document.querySelectorAll('.pricing__paper-tab');
    var bodies = document.querySelectorAll('.pricing__body');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var paper = tab.dataset.paper;

        tabs.forEach(function (t) {
          t.classList.remove('pricing__paper-tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('pricing__paper-tab--active');
        tab.setAttribute('aria-selected', 'true');

        bodies.forEach(function (body) {
          if (body.dataset.paper === paper) {
            body.classList.remove('pricing__body--hidden');
          } else {
            body.classList.add('pricing__body--hidden');
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundles"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var reveals = document.querySelectorAll('.reveal');
    if (!reveals.length) return;
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          var el = e.target;
          var delay = el.dataset.delay ? parseInt(el.dataset.delay) : 0;
          setTimeout(function() { el.classList.add('visible'); }, delay);
          obs.unobserve(el);
        }
      });
    }, { threshold: 0.1 });
    reveals.forEach(function(el) { obs.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
(function() {
  // +/- qty buttons → update input and submit form
  document.querySelectorAll('.cart-item__qty-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var line = btn.dataset.line;
      var input = document.querySelector('.cart-item__qty-input[data-line="' + line + '"]');
      if (!input) return;
      var val = parseInt(input.value) || 0;
      if (btn.dataset.action === 'plus') val = val + 1;
      if (btn.dataset.action === 'minus') val = Math.max(0, val - 1);
      input.value = val;
      // Auto-submit on change
      updateCart(line, val);
    });
  });

  function updateCart(line, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function() { window.location.reload(); })
    .catch(function() { window.location.reload(); });
  }

  // Also update on manual input change
  document.querySelectorAll('.cart-item__qty-input').forEach(function(input) {
    input.addEventListener('change', function() {
      var val = Math.max(0, parseInt(input.value) || 0);
      input.value = val;
      updateCart(input.dataset.line, val);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.querySelectorAll('.site-footer__copy-email').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var email = btn.dataset.email;
      var confirm = btn.parentElement.querySelector('.site-footer__copy-confirm');
      navigator.clipboard.writeText(email).then(function() {
        confirm.textContent = 'Copied!';
        confirm.classList.add('visible');
        setTimeout(function() { confirm.classList.remove('visible'); }, 2000);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var header = document.getElementById('site-header');
    var toggle = document.getElementById('nav-toggle');
    var menu = document.getElementById('mobile-menu');

    window.addEventListener('scroll', function() {
      if (window.scrollY > 20) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }, { passive: true });

    if (toggle && menu) {
      toggle.addEventListener('click', function() {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', !expanded);
        menu.setAttribute('aria-hidden', expanded);
        menu.classList.toggle('open', !expanded);
      });
    }

    // Close menu on link click
    document.querySelectorAll('.site-nav__mobile-link').forEach(function(link) {
      link.addEventListener('click', function() {
        toggle.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-hidden', 'true');
        menu.classList.remove('open');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var reveals = document.querySelectorAll('.reveal');
    if (!reveals.length) return;
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          var delay = e.target.dataset.delay || 0;
          setTimeout(function() { e.target.classList.add('visible'); }, parseInt(delay));
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    reveals.forEach(function(el) { obs.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var reveals = document.querySelectorAll('.reveal');
    if (!reveals.length) return;
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          var el = e.target;
          var delay = el.dataset.delay ? parseInt(el.dataset.delay) : 0;
          setTimeout(function() { el.classList.add('visible'); }, delay);
          obs.unobserve(el);
        }
      });
    }, { threshold: 0.1 });
    reveals.forEach(function(el) { obs.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('order-builder');
  if (!root) return;

  // ── State ──
  var s = { step: 1, productType: null, finish: null, size: null, qty: null, fileName: null, fileUrl: null, instructions: '' };

  // ── Pricing (per finish × size × qty) ──
  var P = {
    white: {
      'soft-matte':     { '1.5':{16:11,50:35,100:41,200:61,300:77,500:104,1000:183},  '2':{16:12,50:35,100:46,200:69,300:86,500:117,1000:206},  '3':{16:15,50:59,100:84,200:118,300:150,500:206,1000:331},  '4':{16:18,50:59,100:107,200:159,300:206,500:294,1000:486} },
      'glossy':         { '1.5':{16:11,50:35,100:41,200:61,300:77,500:104,1000:183},  '2':{16:12,50:35,100:46,200:69,300:86,500:117,1000:206},  '3':{16:15,50:59,100:84,200:118,300:150,500:206,1000:331},  '4':{16:18,50:59,100:107,200:159,300:206,500:294,1000:486} },
      'textured-matte': { '1.5':{16:12,50:37,100:58,200:75,300:92,500:121,1000:189}, '2':{16:12,50:37,100:65,200:84,300:103,500:136,1000:212}, '3':{16:19,50:78,100:109,200:154,300:194,500:267,1000:430}, '4':{16:23,50:100,100:139,200:207,300:268,500:382,1000:632} },
      'holographic':    { '1.5':{16:13,50:39,100:59,200:77,300:94,500:124,1000:193}, '2':{16:13,50:39,100:66,200:86,300:106,500:139,1000:217}, '3':{16:20,50:80,100:111,200:157,300:199,500:273,1000:440}, '4':{16:24,50:102,100:142,200:212,300:275,500:391,1000:646} }
    },
    clear: {
      'soft-matte':     { '1.5':{16:11,50:34,100:53,200:79,300:100,500:135,1000:238},  '2':{16:14,50:58,100:89,200:127,300:161,500:224,1000:364},  '3':{16:18,50:68,100:105,200:148,300:187,500:257,1000:414},  '4':{16:22,50:87,100:134,200:199,300:258,500:367,1000:607} },
      'glossy':         { '1.5':{16:11,50:34,100:53,200:79,300:100,500:135,1000:238},  '2':{16:14,50:58,100:89,200:127,300:161,500:224,1000:364},  '3':{16:18,50:68,100:105,200:148,300:187,500:257,1000:414},  '4':{16:22,50:87,100:134,200:199,300:258,500:367,1000:607} },
      'textured-matte': { '1.5':{16:16,50:49,100:75,200:98,300:120,500:157,1000:246}, '2':{16:18,50:61,100:94,200:135,300:171,500:238,1000:386}, '3':{16:24,50:75,100:115,200:163,300:207,500:284,1000:458}, '4':{16:29,50:96,100:147,200:220,300:285,500:406,1000:672} },
      'holographic':    { '1.5':{16:16,50:50,100:77,200:100,300:122,500:161,1000:251}, '2':{16:20,50:64,100:98,200:140,300:177,500:247,1000:400}, '3':{16:25,50:78,100:120,200:170,300:214,500:295,1000:475}, '4':{16:30,50:99,100:153,200:228,300:296,500:421,1000:698} }
    }
  };

  function price() {
    if (!s.finish || !s.size || !s.qty) return null;
    var t = P[s.productType] || P.white;
    return (t[s.finish] && t[s.finish][s.size]) ? (t[s.finish][s.size][s.qty] || null) : null;
  }

  // ── Variant IDs (type × finish × size × qty) ──
  var VARIANTS = {
    white: {
      'soft-matte':     { '1.5':{16:41141587902536,50:41141587935304,100:41141587968072,200:41141588000840,300:41141588033608,500:41141588066376,1000:41141588099144}, '2':{16:41141588131912,50:41141588164680,100:41141588197448,200:41141588230216,300:41141588262984,500:41141588295752,1000:41141588328520}, '3':{16:41141588361288,50:41141588394056,100:41141588426824,200:41141588459592,300:41141588492360,500:41141588525128,1000:41141588557896}, '4':{16:41141588590664,50:41141588623432,100:41141588656200,200:41141588688968,300:41141588721736,500:41141588754504,1000:41141588787272} },
      'glossy':         { '1.5':{16:41141588820040,50:41141588852808,100:41141588885576,200:41141588918344,300:41141588951112,500:41141588983880,1000:41141589016648}, '2':{16:41141589049416,50:41141589082184,100:41141589114952,200:41141589147720,300:41141589180488,500:41141589213256,1000:41141589246024}, '3':{16:41141589278792,50:41141589311560,100:41141589344328,200:41141589377096,300:41141589409864,500:41141589442632,1000:41141589475400}, '4':{16:41141589508168,50:41141589540936,100:41141589573704,200:41141589606472,300:41141589639240,500:41141589672008,1000:41141589704776} },
      'textured-matte': { '1.5':{16:41141589737544,50:41141589770312,100:41141589803080,200:41141589835848,300:41141589868616,500:41141589901384,1000:41141589934152}, '2':{16:41141589966920,50:41141589999688,100:41141590032456,200:41141590065224,300:41141590097992,500:41141590130760,1000:41141590163528}, '3':{16:41141590196296,50:41141590229064,100:41141590261832,200:41141590294600,300:41141590327368,500:41141590360136,1000:41141590392904}, '4':{16:41141590425672,50:41141590458440,100:41141590491208,200:41141590523976,300:41141590556744,500:41141590589512,1000:41141590622280} },
      'holographic':    { '1.5':{16:41141590655048,50:41141590687816,100:41141590720584,200:41141590753352,300:41141590786120,500:41141590818888,1000:41141590851656}, '2':{16:41141590884424,50:41141590917192,100:41141590949960,200:41141590982728,300:41141591015496,500:41141591048264,1000:41141591081032}, '3':{16:41141591113800,50:41141591146568,100:41141591179336,200:41141591212104,300:41141591244872,500:41141591277640,1000:41141591310408}, '4':{16:41141591343176,50:41141591375944,100:41141591408712,200:41141591441480,300:41141591474248,500:41141591507016,1000:41141591539784} }
    },
    clear: {
      'soft-matte':     { '1.5':{16:41141591572552,50:41141591605320,100:41141591638088,200:41141591670856,300:41141591703624,500:41141591736392,1000:41141591769160}, '2':{16:41141591801928,50:41141591834696,100:41141591867464,200:41141591900232,300:41141591933000,500:41141591965768,1000:41141591998536}, '3':{16:41141592031304,50:41141592064072,100:41141592096840,200:41141592129608,300:41141592162376,500:41141592195144,1000:41141592227912}, '4':{16:41141592260680,50:41141592293448,100:41141592326216,200:41141592358984,300:41141592391752,500:41141592424520,1000:41141592457288} },
      'glossy':         { '1.5':{16:41141592490056,50:41141592522824,100:41141592555592,200:41141592588360,300:41141592621128,500:41141592653896,1000:41141592686664}, '2':{16:41141592719432,50:41141592752200,100:41141592784968,200:41141592817736,300:41141592850504,500:41141592883272,1000:41141592916040}, '3':{16:41141592948808,50:41141592981576,100:41141593014344,200:41141593047112,300:41141593079880,500:41141593112648,1000:41141593145416}, '4':{16:41141593178184,50:41141593210952,100:41141593243720,200:41141593276488,300:41141593309256,500:41141593342024,1000:41141593374792} },
      'textured-matte': { '1.5':{16:41141593407560,50:41141593440328,100:41141593473096,200:41141593505864,300:41141593538632,500:41141593571400,1000:41141593604168}, '2':{16:41141593636936,50:41141593669704,100:41141593702472,200:41141593735240,300:41141593768008,500:41141593800776,1000:41141593833544}, '3':{16:41141593866312,50:41141593899080,100:41141593931848,200:41141593964616,300:41141593997384,500:41141594030152,1000:41141594062920}, '4':{16:41141594095688,50:41141594128456,100:41141594161224,200:41141594193992,300:41141594226760,500:41141594259528,1000:41141594292296} },
      'holographic':    { '1.5':{16:41141594357832,50:41141594390600,100:41141594423368,200:41141594456136,300:41141594488904,500:41141594521672,1000:41141594554440}, '2':{16:41141594587208,50:41141594619976,100:41141594652744,200:41141594685512,300:41141594718280,500:41141594751048,1000:41141594783816}, '3':{16:41141594816584,50:41141594849352,100:41141594882120,200:41141594914888,300:41141594947656,500:41141594980424,1000:41141595013192}, '4':{16:41141595045960,50:41141595078728,100:41141595111496,200:41141595144264,300:41141595177032,500:41141595209800,1000:41141595242568} }
    }
  };

  // ── Finish preview data ──
  var _cdn = '/cdn/shop/t/5/assets/';
  var FINISH_PREVIEWS = {
    'soft-matte':     { img: _cdn + 'finish-soft-matte-standard.jpg',    imgClear: _cdn + 'finish-soft-matte-clear.jpg',    video: _cdn + 'finish-soft-matte.mp4' },
    'textured-matte': { img: _cdn + 'finish-textured-matte-standard.jpg', imgClear: _cdn + 'finish-textured-matte-clear.jpg', video: _cdn + 'finish-textured-matte.mp4' },
    'glossy':         { img: _cdn + 'finish-glossy-standard.jpg',        imgClear: _cdn + 'finish-glossy-clear.jpg',         video: _cdn + 'finish-glossy.mp4' },
    'holographic':    { img: _cdn + 'finish-holographic-standard.jpg',   imgClear: _cdn + 'finish-holographic-clear.jpg',    video: _cdn + 'finish-holographic.mp4' }
  };

  function updateFinishPreview(finishVal) {
    var previewEl  = document.getElementById('ob-finish-preview');
    var previewImg = document.getElementById('ob-preview-img');
    var previewVid = document.getElementById('ob-preview-video');
    var previewCap = document.getElementById('ob-preview-caption');
    if (!previewEl) return;

    var data = FINISH_PREVIEWS[finishVal] || {};
    var imgSrcStd   = data.img      || '';
    var imgSrcClear = data.imgClear || '';
    // Valid CDN URLs contain '/assets/' followed by a filename
    function valid(url) { return url && url.indexOf('/assets/') !== -1 && url.split('/assets/').pop().length > 0; }
    // For clear type: prefer clear image; fallback to standard. For standard: prefer standard; fallback to clear.
    var imgSrc = (s.productType === 'clear')
      ? (valid(imgSrcClear) ? imgSrcClear : (valid(imgSrcStd) ? imgSrcStd : ''))
      : (valid(imgSrcStd)   ? imgSrcStd   : (valid(imgSrcClear) ? imgSrcClear : ''));
    var vidSrc = valid(data.video) ? data.video : '';
    var hasImg = imgSrc !== '';
    var hasVid = vidSrc !== '';
    var capText = (finishVal.charAt(0).toUpperCase() + finishVal.slice(1)).replace(/-/g, ' ') + ' — see how it looks on real stickers';

    if (!hasImg && !hasVid) return;

    var wasHidden = previewEl.hidden;
    previewEl.classList.remove('ob__finish-preview--visible');
    setTimeout(function() {
      previewEl.classList.toggle('ob__finish-preview--no-img',     !hasImg);
      previewEl.classList.toggle('ob__finish-preview--no-video',   !hasVid);
      previewEl.classList.toggle('ob__finish-preview--img-only',   hasImg && !hasVid);
      previewEl.classList.toggle('ob__finish-preview--video-only', hasVid && !hasImg);
      if (hasImg) { previewImg.src = imgSrc; previewImg.alt = capText; }
      if (hasVid) { previewVid.src = vidSrc; previewVid.load(); previewVid.play().catch(function(){}); }
      previewCap.textContent = capText;
      previewEl.hidden = false;
      requestAnimationFrame(function() { previewEl.classList.add('ob__finish-preview--visible'); });
    }, wasHidden ? 0 : 180);
  }

  // ── Selectors ──
  function all(sel) { return root.querySelectorAll(sel); }
  function one(sel) { return root.querySelector(sel); }

  // ── Render ──
  function showStep(n) {
    all('.ob__panel').forEach(function (p) { p.classList.toggle('ob__panel--active', +p.dataset.panel === n); });
    all('.ob__step').forEach(function (st) {
      var i = +st.dataset.step;
      st.classList.toggle('ob__step--active', i === n);
      st.classList.toggle('ob__step--done', i < n);
    });
    one('#ob-back').style.visibility = n > 1 ? 'visible' : 'hidden';
    if (n === 2) one('.ob__panel-sub--finish').textContent = s.productType === 'clear'
      ? 'All finishes available on clear vinyl. Not sure? Order a sample pack first.'
      : 'All finishes on white vinyl. Not sure? Order a sample pack first.';
    if (n === 3) updatePrices();
    if (n === 5) renderReview();
    updateContinueBtn();
  }

  function stepReady(n) {
    if (n === 1) return !!s.productType;
    if (n === 2) return !!s.finish;
    if (n === 3) return !!s.size && !!s.qty;
    return true; // steps 4 & 5 are always continuable
  }

  function updateContinueBtn() {
    var btn = one('#ob-continue');
    var notReady = !stepReady(s.step);
    btn.classList.toggle('ob__continue-btn--not-ready', notReady);
    var labels = { 4: 'REVIEW ORDER', 5: 'ADD TO CART' };
    var label = labels[s.step] || 'CONTINUE';
    btn.innerHTML = label + ' <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';
    updateRequiredTags();
  }

  function updateRequiredTags() {
    var map = { 'ob-req-type': !!s.productType, 'ob-req-finish': !!s.finish, 'ob-req-size': !!s.size, 'ob-req-qty': !!s.qty };
    Object.keys(map).forEach(function(id) {
      var el = one('#' + id);
      if (!el) return;
      var done = map[id];
      el.classList.toggle('ob__required-tag--done', done);
      el.textContent = done ? '✓ Done' : 'Required';
    });
  }

  function highlightMissing(step) {
    function shake(id) {
      var el = one(id);
      if (!el) return;
      el.classList.remove('ob--shake');
      void el.offsetWidth;
      el.classList.add('ob--shake');
      el.addEventListener('animationend', function h() { el.classList.remove('ob--shake'); el.removeEventListener('animationend', h); });
    }
    function hint(id) {
      var el = one(id);
      if (!el) return;
      el.classList.add('visible');
      clearTimeout(el._t);
      el._t = setTimeout(function() { el.classList.remove('visible'); }, 4500);
    }
    if (step === 1 && !s.productType) { shake('#ob-grid-type');   hint('#ob-hint-type'); }
    if (step === 2 && !s.finish)      { shake('#ob-grid-finish');  hint('#ob-hint-finish'); }
    if (step === 3) {
      if (!s.size) { shake('#ob-grid-size'); hint('#ob-hint-size'); }
      if (!s.qty)  { shake('#ob-grid-qty');  hint('#ob-hint-qty'); }
    }
  }

  function updatePrices() {
    if (!s.finish) return;
    var base = P[s.productType] || P.white;
    var finData = base[s.finish];
    all('.ob__qty-price').forEach(function (el) {
      var qty = +el.dataset.qty;
      var p = finData && s.size && finData[s.size] ? finData[s.size][qty] : null;
      el.textContent = p ? '$' + p : '';
    });
    updateSummaryBar();
  }

  function updateSummaryBar() {
    var bar = one('#ob-summary-bar');
    var txt = one('#ob-summary-text');
    var p = price();
    if (s.size && s.qty && p) {
      txt.textContent = s.qty + ' stickers at ' + s.size + '" — $' + p + '. Free US shipping included.';
      bar.style.display = 'flex';
    } else {
      bar.style.display = 'none';
    }
  }

  var FINISH_LABELS = { 'soft-matte':'Soft Matte', 'textured-matte':'Textured Matte', 'glossy':'Glossy', 'holographic':'Holographic' };
  var TYPE_LABELS   = { 'white':'Standard Stickers', 'clear':'Clear Stickers' };

  function renderReview() {
    var rows = [
      ['Product',  TYPE_LABELS[s.productType]  || '—'],
      ['Finish',   FINISH_LABELS[s.finish]      || '—'],
      ['Size',     s.size ? s.size + '" (longest side)' : '—'],
      ['Quantity', s.qty  ? s.qty + ' stickers'         : '—'],
      ['Design',   s.fileName || 'Email to hello@daintyfavors.com after ordering'],
    ];
    if (s.instructions) rows.push(['Instructions', s.instructions]);

    one('#ob-review-rows').innerHTML = rows.map(function (r) {
      return '<div class="ob__review-row"><span class="ob__review-label">' + r[0] + '</span><span class="ob__review-value">' + r[1] + '</span></div>';
    }).join('');

    var p = price();
    one('#ob-review-total').innerHTML = p
      ? '<div class="ob__review-price"><span>Estimated price</span><strong>$' + p + '</strong></div><p class="ob__review-shipping">Free US shipping · Taxes at checkout · Proof sent within 2 hours · 24h to approve</p>'
      : '';
  }

  // ── Option card clicks ──
  all('.ob__option-card').forEach(function (card) {
    card.addEventListener('click', function () {
      var field = card.dataset.field, val = card.dataset.value;
      all('.ob__option-card[data-field="' + field + '"]').forEach(function (c) { c.classList.remove('ob__option-card--selected'); });
      card.classList.add('ob__option-card--selected');
      if (field === 'productType') s.productType = val;
      if (field === 'finish') {
        s.finish = val;
        updateFinishPreview(val);
      }
      if (field === 'size')        { s.size = val;  updatePrices(); }
      if (field === 'qty')         { s.qty  = +val; updateSummaryBar(); }
      updateContinueBtn();
    });
  });

  // ── Navigation ──
  one('#ob-continue').addEventListener('click', function () {
    if (!stepReady(s.step)) { highlightMissing(s.step); return; }
    if (s.step === 5) { addToCart(); return; }
    s.step++;
    showStep(s.step);
    window.scrollTo({ top: root.offsetTop - 16, behavior: 'smooth' });
  });
  one('#ob-back').addEventListener('click', function () {
    if (s.step > 1) { s.step--; showStep(s.step); window.scrollTo({ top: root.offsetTop - 16, behavior: 'smooth' }); }
  });

  // ── Stepper click navigation ──
  all('.ob__step').forEach(function (st) {
    st.addEventListener('click', function () {
      var target = +st.dataset.step;
      if (target === s.step) return;
      if (target < s.step) {
        // Going back — always allowed
        s.step = target;
        showStep(s.step);
        window.scrollTo({ top: root.offsetTop - 16, behavior: 'smooth' });
      } else {
        // Going forward — only if all steps between current and target are ready
        var canAdvance = true;
        for (var i = s.step; i < target; i++) {
          if (!stepReady(i)) { canAdvance = false; break; }
        }
        if (canAdvance) {
          s.step = target;
          showStep(s.step);
          window.scrollTo({ top: root.offsetTop - 16, behavior: 'smooth' });
        }
      }
    });
  });

  // ── File upload (real — Uploadcare CDN) ──────────────────────────────────
  // Files are uploaded to Uploadcare's CDN. The permanent download URL is
  // saved as a line-item property on the order so you can access it from
  // Shopify admin without the customer having to email anything.
  var UPLOADCARE_KEY = '7dc9a08d82672a914e0d';
  var zone      = one('#ob-upload-zone');
  var input     = one('#ob-file-input');
  var nameEl    = one('#ob-file-name');
  var progressWrap = one('#ob-upload-progress');
  var progressBar  = one('#ob-upload-progress-bar');
  var progressText = one('#ob-upload-progress-text');

  zone.addEventListener('click', function () { if (!zone.classList.contains('ob__upload-zone--uploading')) input.click(); });
  zone.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') input.click(); });
  zone.addEventListener('dragover', function (e) { e.preventDefault(); zone.classList.add('ob__upload-zone--drag'); });
  zone.addEventListener('dragleave', function () { zone.classList.remove('ob__upload-zone--drag'); });
  zone.addEventListener('drop', function (e) {
    e.preventDefault();
    zone.classList.remove('ob__upload-zone--drag');
    if (e.dataTransfer.files[0]) uploadFile(e.dataTransfer.files[0]);
  });
  input.addEventListener('change', function () { if (input.files[0]) uploadFile(input.files[0]); });

  function uploadFile(f) {
    if (!f) return;

    // Show uploading state
    zone.classList.add('ob__upload-zone--uploading');
    nameEl.style.display = 'none';
    progressWrap.style.display = 'block';
    progressBar.style.width = '0%';
    progressText.textContent = 'Uploading…';
    s.fileUrl = null;
    s.fileName = null;

    var formData = new FormData();
    formData.append('UPLOADCARE_PUB_KEY', UPLOADCARE_KEY);
    formData.append('UPLOADCARE_STORE', '1');  // permanent storage
    formData.append('file', f);

    var xhr = new XMLHttpRequest();
    xhr.open('POST', 'https://upload.uploadcare.com/base/');

    xhr.upload.addEventListener('progress', function (e) {
      if (e.lengthComputable) {
        var pct = Math.round((e.loaded / e.total) * 90);
        progressBar.style.width = pct + '%';
        progressText.textContent = 'Uploading… ' + pct + '%';
      }
    });

    xhr.addEventListener('load', function () {
      progressBar.style.width = '100%';
      if (xhr.status === 200) {
        try {
          var res = JSON.parse(xhr.responseText);
          var fileId = res.file;
          var fileUrl = 'https://ucarecdn.com/' + fileId + '/';

          s.fileUrl  = fileUrl;
          s.fileName = f.name;

          progressWrap.style.display = 'none';
          nameEl.textContent = '✓ ' + f.name + ' — uploaded';
          nameEl.style.display = 'block';
          zone.classList.remove('ob__upload-zone--uploading');
          zone.classList.add('ob__upload-zone--has-file');
        } catch (err) {
          uploadError('Upload failed — please try again.');
        }
      } else {
        uploadError('Upload failed (' + xhr.status + ') — please try again.');
      }
    });

    xhr.addEventListener('error', function () {
      uploadError('Upload failed — check your connection and try again.');
    });

    xhr.send(formData);
  }

  function uploadError(msg) {
    zone.classList.remove('ob__upload-zone--uploading');
    progressWrap.style.display = 'none';
    nameEl.textContent = '⚠ ' + msg;
    nameEl.style.display = 'block';
    s.fileUrl = null;
    s.fileName = null;
  }

  one('#ob-instructions').addEventListener('input', function () { s.instructions = this.value; });

  // ── Add to cart ──
  function showOrderError(msg, goToStep) {
    var el = one('#ob-error');
    el.textContent = msg;
    el.classList.add('visible');
    clearTimeout(el._hideTimer);
    el._hideTimer = setTimeout(function() { el.classList.remove('visible'); }, 5000);
    if (goToStep) {
      s.step = goToStep;
      showStep(goToStep);
      window.scrollTo({ top: root.offsetTop - 16, behavior: 'smooth' });
      setTimeout(function() { highlightMissing(goToStep); }, 120);
    }
  }

  function addToCart() {
    // Validate required selections — file upload is optional
    if (!s.productType) { showOrderError('Please select a product type first.', 1); return; }
    if (!s.finish)       { showOrderError('Please select a finish before continuing.', 2); return; }
    if (!s.size)         { showOrderError('Please select a size before continuing.', 3); return; }
    if (!s.qty)          { showOrderError('Please enter a quantity before continuing.', 3); return; }

    var typeKey = s.productType === 'clear' ? 'clear' : 'white';
    var variantId = VARIANTS[typeKey] && VARIANTS[typeKey][s.finish] && VARIANTS[typeKey][s.finish][String(s.size)]
      ? VARIANTS[typeKey][s.finish][String(s.size)][s.qty]
      : null;
    if (!variantId) { alert('No product variant found for that combination. Please contact us at hello@daintyfavors.com to order.'); return; }

    var props = {
      'Product Type':  TYPE_LABELS[s.productType]  || s.productType,
      'Finish':        FINISH_LABELS[s.finish]      || s.finish,
      'Size':          s.size + '" (longest side)',
      'Quantity':      s.qty + ' stickers',
    };
    var p = price();
    if (p)               props['Estimated Price'] = '$' + p + ' (excl. taxes · free shipping included)';
    if (s.instructions)  props['Special Instructions'] = s.instructions;
    if (s.fileUrl)       props['Design File URL'] = s.fileUrl;
    if (s.fileName)      props['Design File Name'] = s.fileName;
    if (!s.fileUrl)      props['Design File'] = 'Not uploaded — customer to email hello@daintyfavors.com';

    var btn = one('#ob-continue');
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: props })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) {
        btn.disabled = false;
        updateContinueBtn();
        alert('Could not add to cart: ' + (data.description || 'please try again.'));
      } else {
        window.location.href = '/cart';
      }
    })
    .catch(function () { btn.disabled = false; updateContinueBtn(); });
  }

  // ── Init: pre-select type/finish from product metadata ──
  var presetType   = root.dataset.presetType;
  var presetFinish = root.dataset.presetFinish;
  var startStep    = 1;

  if (presetType) {
    s.productType = presetType;
    var typeCard = root.querySelector('.ob__option-card[data-field="productType"][data-value="' + presetType + '"]');
    if (typeCard) typeCard.classList.add('ob__option-card--selected');
    startStep = 2;
  }
  if (presetFinish) {
    s.finish = presetFinish;
    var finishCard = root.querySelector('.ob__option-card[data-field="finish"][data-value="' + presetFinish + '"]');
    if (finishCard) finishCard.classList.add('ob__option-card--selected');
    startStep = 3;
  }

  s.step = startStep;
  showStep(startStep);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sample-builder"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.getElementById('sample-builder');
    if (!root) return;

    // Prices come straight from the Shopify variants (in cents), built in
    // Liquid above. The displayed price is therefore always exactly what the
    // customer is charged at checkout — no hardcoded table to drift out of sync.
    var PACK_PRICE_MAP    = JSON.parse(root.dataset.packPriceMap    || '{}');
    var VARIETY_PRICE_MAP = JSON.parse(root.dataset.varietyPriceMap || '{}');

    var FINISH_LABELS = {
      'soft-matte':     'Soft Matte',
      'glossy':         'Glossy',
      'textured-matte': 'Textured Matte',
      'holographic':    'Holographic'
    };

    var s = { type: 'die-cut', finish: 'soft-matte', size: '1.5', qty: 8 };
    var interacted = { type: false, finish: false, size: false, qty: false };

    function isVariety() { return s.qty === 'variety'; }

    function getPriceCents() {
      if (isVariety()) return VARIETY_PRICE_MAP[s.type + '|2'];
      return PACK_PRICE_MAP[s.type + '|' + s.finish + '|' + s.size + '|' + s.qty];
    }
    function formatPrice(cents) {
      if (cents == null) return null;
      var d = cents / 100;
      return Number.isInteger(d) ? String(d) : d.toFixed(2);
    }
    function getPrice() {
      return formatPrice(getPriceCents());
    }

    function getQtyCount() {
      return isVariety() ? 6 : s.qty;
    }

    function lockSizeTo2() {
      var sizeGroup = document.getElementById('sb-size');
      sizeGroup.querySelectorAll('.sb__option').forEach(function(b) {
        b.classList.remove('sb__option--active');
      });
      var btn2 = sizeGroup.querySelector('[data-value="2"]');
      if (btn2) btn2.classList.add('sb__option--active');
      s.size = '2';
    }

    function sbShake(id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.classList.remove('df-shake');
      void el.offsetWidth;
      el.classList.add('df-shake');
      el.addEventListener('animationend', function h() { el.classList.remove('df-shake'); el.removeEventListener('animationend', h); });
    }
    function sbHint(id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.classList.add('visible');
      clearTimeout(el._t);
      el._t = setTimeout(function() { el.classList.remove('visible'); }, 4500);
    }
    function updateRequiredTags() {
      var variety = isVariety();
      var tags = {
        'sb-req-type':   interacted.type   && !!s.type,
        'sb-req-finish': interacted.finish && (variety || !!s.finish),
        'sb-req-size':   interacted.size   && (variety || !!s.size),
        'sb-req-qty':    interacted.qty    && (!!s.qty || s.qty === 'variety')
      };
      Object.keys(tags).forEach(function(id) {
        var el = document.getElementById(id);
        if (!el) return;
        el.classList.toggle('df-required-tag--done', tags[id]);
        el.textContent = tags[id] ? '✓ Done' : 'Required';
      });
    }

    function updateUI() {
      var variety = isVariety();
      var finishStep = document.getElementById('sb-finish-step');
      var finishNote = document.getElementById('sb-finish-note');
      var sizeStep   = document.getElementById('sb-size-step');

      if (variety) {
        finishStep.classList.add('sb__step--disabled');
        finishNote.hidden = false;
        sizeStep.classList.add('sb__step--disabled');
        lockSizeTo2();
      } else {
        finishStep.classList.remove('sb__step--disabled');
        finishNote.hidden = true;
        sizeStep.classList.remove('sb__step--disabled');
      }

      var priceStr = getPrice();
      document.getElementById('sb-price').textContent = priceStr ? '$' + priceStr : '—';
      document.getElementById('sb-lbl-type').textContent   = s.type === 'die-cut' ? 'Standard' : 'Clear';
      document.getElementById('sb-lbl-finish').textContent = variety ? 'All 4 finishes' : FINISH_LABELS[s.finish];
      document.getElementById('sb-lbl-size').textContent   = variety ? '2"' : s.size + '"';
      document.getElementById('sb-lbl-qty').textContent    = variety ? '6 stickers (variety pack)' : s.qty + ' stickers';
      updateRequiredTags();
    }

    function bindGroup(groupId, key) {
      var group = document.getElementById(groupId);
      if (!group) return;
      group.querySelectorAll('.sb__option').forEach(function(btn) {
        btn.addEventListener('click', function() {
          group.querySelectorAll('.sb__option').forEach(function(b) {
            b.classList.remove('sb__option--active');
          });
          btn.classList.add('sb__option--active');
          var val = btn.dataset.value;
          s[key] = (key === 'qty' && val !== 'variety') ? parseInt(val) : val;
          interacted[key] = true;
          updateUI();
          document.getElementById('sb-success').hidden = true;
          document.getElementById('sb-cta-label').textContent = 'Add to Cart';
        });
      });
    }

    bindGroup('sb-type',   'type');
    bindGroup('sb-finish', 'finish');
    bindGroup('sb-size',   'size');
    bindGroup('sb-qty',    'qty');

    updateUI();

    var VARIETY_MAP = JSON.parse(root.dataset.varietyMap || '{}');
    var PACK_MAP    = JSON.parse(root.dataset.packMap    || '{}');

    function getVariantId() {
      if (isVariety()) {
        // Variety pack: keyed by type + size (always priced at 2")
        return VARIETY_MAP[s.type + '|2'] || 0;
      } else {
        // Regular pack: keyed by type + finish + size + qty
        return PACK_MAP[s.type + '|' + s.finish + '|' + s.size + '|' + s.qty] || 0;
      }
    }

    document.getElementById('sb-add-to-cart').addEventListener('click', function() {
      var variantId = getVariantId();

      // Validate required selections
      var variety = isVariety();
      if (!s.type)                      { sbShake('sb-type');   sbHint('sb-hint-type');   return; }
      if (!variety && !s.finish)        { sbShake('sb-finish'); sbHint('sb-hint-finish'); return; }
      if (!variety && !s.size)          { sbShake('sb-size');   sbHint('sb-hint-size');   return; }
      if (!s.qty && s.qty !== 'variety'){ sbShake('sb-qty');    sbHint('sb-hint-qty');    return; }
      if (!variantId)                   { alert('Product not available. Please contact us at hello@daintyfavors.com.'); return; }

      var btn   = document.getElementById('sb-add-to-cart');
      var label = document.getElementById('sb-cta-label');
      btn.disabled = true;
      label.textContent = 'Adding…';

      var variety     = isVariety();
      var price       = getPrice();
      var finishLabel = variety ? 'Soft Matte ×2, Glossy ×2, Textured Matte ×1, Holographic ×1' : FINISH_LABELS[s.finish];
      var packLabel   = variety ? 'Variety Pack (6 stickers)' : s.qty + ' stickers';
      var cartQty = 1; // always add 1 pack to cart; sticker count is a label only

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: cartQty,
            properties: {
              'Paper type': s.type === 'die-cut' ? 'Standard' : 'Clear',
              'Finish': finishLabel,
              'Size': s.size + '"',
              'Pack': packLabel,
              'Price': '$' + price
            }
          }]
        })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        btn.disabled = false;
        if (data.status) {
          label.textContent = 'Add to Cart';
          alert(data.description || 'Could not add to cart.');
        } else {
          label.textContent = 'Add to Cart';
          document.getElementById('sb-success').hidden = false;

          // Update cart count in header
          var cartCount = document.querySelector('.site-nav__cart-count');
          if (cartCount) {
            cartCount.textContent = parseInt(cartCount.textContent || 0) + cartQty;
          } else {
            var cartLink = document.querySelector('.site-nav__cart');
            if (cartLink) {
              var badge = document.createElement('span');
              badge.className = 'site-nav__cart-count';
              badge.textContent = cartQty;
              cartLink.appendChild(badge);
            }
          }
        }
      })
      .catch(function() {
        btn.disabled = false;
        label.textContent = 'Add to Cart';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sample-promo"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var reveals = document.querySelectorAll('.spromo .reveal');
    if (!reveals.length) return;
    if (!('IntersectionObserver' in window)) {
      reveals.forEach(function(el) { el.classList.add('visible'); });
      return;
    }
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          var el = e.target;
          var delay = el.dataset.delay ? parseInt(el.dataset.delay) : 0;
          setTimeout(function() { el.classList.add('visible'); }, delay);
          obs.unobserve(el);
        }
      });
    }, { threshold: 0.1 });
    reveals.forEach(function(el) { obs.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();
})();
